"use strict";

var _reactNative = require("react-native");

module.exports = {
    get: function get(key) {
        return _reactNative.AsyncStorage.getItem(key).catch(function (err) {
            throw new Error("[react-native-storage-wrapper] - " + err);
        });
    },
    set: function set(key, value) {
        return _reactNative.AsyncStorage.setItem(key, value).catch(function (err) {
            throw new Error("[react-native-storage-wrapper] - " + err);
        });
    },
    del: function del(key) {
        return _reactNative.AsyncStorage.removeItem(key).catch(function (err) {
            throw new Error("[react-native-storage-wrapper] - " + err);
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-native-storage-wrapper/lib/index.js
// module id = 272
// module chunks = 0